module.exports = __webpack_public_path__ + "static/media/icon-button.bb910398.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/icon-button.md
// module id = 379
// module chunks = 0